import { ApplicationInsights, DistributedTracingModes } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ClickAnalyticsPlugin } from '@microsoft/applicationinsights-clickanalytics-js';
import customHistory from '@/core/customHistory.ts';
import { CURRENT_BUILD_HASH } from '@/app/utils/buildHash.ts';
import { applyTelemetrySession } from '@/app/utils/telemetrySession.ts';

const reactPlugin = new ReactPlugin();
const clickPluginInstance = new ClickAnalyticsPlugin();
const clickPluginConfig = {
  autoCapture: true
};
const correlationHeaderExcludedDomains = [
  'munin-sklls-next.westeurope.cloudapp.azure.com',
  'scenarioeditor-backend-app-dev.azurewebsites.net',
  'scenarioeditor-backend-app-prod.azurewebsites.net',
  'app.sklls.ai'
];

const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.APP_INSIGHTS_CONNECTION_STRING,
    // enableAutoRouteTracking: true,
    extensions: [reactPlugin, clickPluginInstance] as unknown as any[],
    extensionConfig: {
      [reactPlugin.identifier]: { history: customHistory },
      [clickPluginInstance.identifier]: clickPluginConfig
    },
    distributedTracingMode: DistributedTracingModes.W3C,
    enableCorsCorrelation: true,
    correlationHeaderExcludedDomains
  }
});

// console.log(process.env.APP_INSIGHTS_CONNECTION_STRING);

appInsights.loadAppInsights();
appInsights.addTelemetryInitializer((envelope) => {
  if (!envelope.tags) {
    envelope.tags = [];
  }
  envelope.tags.push({ 'ai.cloud.role': 'HiSklls' });
  envelope.tags.push({ 'ai.application.ver': CURRENT_BUILD_HASH });
  // Custom dimension so exceptions/traces can be tied to the frontend build that produced them.
  envelope.data = envelope.data || {};
  envelope.data.buildHash = CURRENT_BUILD_HASH;
  applyTelemetrySession(envelope);
});
appInsights.trackPageView();

export default appInsights;
